import React from "react";
import "./Loader.scss";

export const Loader = () => {
  return <span className="loader"></span>;
};
